export default {
  //  Dashboard
  cscore_dashboard_title: "Quản trị hệ thông thông tin",
  cscore_object: 'Đối tượng',
  cscore_group: 'Nhóm',
  cscore_groupUnit: 'Đơn vị',
  cscore_chart: 'Biểu đồ',
  cscore_phase: 'Giai đoạn',
  cscore_period: 'Chu kỳ',
  cscore_from: 'Từ',
  cscore_to: 'Đến',
  cscore_statistic: 'Thống kê',
  cscore_exportPdf: 'Xuất pdf',
  cscore_testing: "Trường thử nghiệm",
  cscore_expired: "Hết hiệu lực",
  cscore_validated: "Còn hiệu lực",
  cscore_expiringSoon: "Sắp hết hiệu lực",
  cscore_gui_email: "Gửi Email yêu cầu báo cáo",
  cscore_de_nghi_cap_phep: "Đề nghị cập nhật cấp phép",
  cscore_tooltip_de_nghi: "Tổ chức/Doanh nghiệp gửi đề nghị cập nhật cấp phép còn thiếu lên hệ thống",
  cscore_ghi_chu_de_nghi: "Không tìm thấy thông tin cấp phép trong hệ thống, bạn có thể gửi đề nghị cập nhật bổ sung cấp phép còn thiếu lên hệ thống",
  cscore_thong_tin_chi_tiet: "Thông tin chi tiết",
  cscore_khoangcach: "Khoảng cách",
  cscore_start: "Bắt đầu",
  cscore_end: "Kết thúc",
  //  Drawer
  cscore_drawer_ctnm: "Công trình nước mặt",
  cscore_drawer_ctnm_qltd: "Thủy điện",
  cscore_drawer_ctnm_qlhc: "Hồ chứa",
  cscore_drawer_ctnm_qltb: "Trạm bơm",
  cscore_drawer_ctnm_qlbd: "Bai đập",
  cscore_drawer_ctnm_qlc: "Cống",
  cscore_drawer_ctnm_qltcn: "Trạm cấp nước",
  cscore_drawer_ctnm_qlnmn: "Nhà máy nước",

  cscore_drawer_ctndd: "Công trình nước dưới đất",
  cscore_drawer_ctndd_tdndd: "Thăm dò",
  cscore_drawer_ctndd_ktndd: "Khai thác",
  cscore_drawer_ctxt: "Công trình xả thải",
  cscore_drawer_ctnb: "Công trình nước biển",

  cscore_drawer_cp_tnn: "Giấy phép",
  cscore_drawer_cp_xt: "Giấy phép xả nước thải",
  cscore_drawer_cp_ktnm: "GP khai thác nước mặt",
  cscore_drawer_cp_ktnb: "GP khai thác nước biển",
  cscore_drawer_cp_tdndd: "GP thăm dò nước dưới đất",
  cscore_drawer_cp_ktndd: "GP khai thác nước dưới đất",
  cscore_drawer_cp_hnkndd: "GP hành nghề khoan nước dưới đất",
  cscore_drawer_cp_tk: "Thống kê",

  cscore_drawer_management_tnn: "Thông tin Tài nguyên nước",
  cscore_drawer_management_svlvs: "Sông và lưu vực sông",
  cscore_drawer_management_vbqppl: "Văn bản quy phạm pháp luật",
  cscore_drawer_management_csdlqh: "Quy hoạch tài nguyên nước",
  cscore_drawer_management_ttdt: "Điều tra đánh giá",
  cscore_drawer_management_bcpckp: "Bảo vệ phòng chống khắc phục",
  cscore_drawer_management_other: "Thông tin tài nguyên nước khác",
  cscore_drawer_management_map: "Dữ liệu bản đồ",
  cscore_drawer_management_kqgqkn:"Kết quả giải quyết kiến nghị cử tri",
  cscore_drawer_management_nccbv:"Nguồn nước cần bảo vệ",
  cscore_drawer_management_kqtlpabc:"Kết quả trả lời phản ánh báo chí",


  cscore_drawer_dm_qt: "Danh mục quan trắc",
  cscore_drawer_qt_tnn: "Quan trắc tài nguyên nước",
  cscore_drawer_qt_tt: "Thông số quan trắc",
  cscore_drawer_qt_tcad: "Quy chuẩn áp dụng",
  cscore_drawer_qt_tcdg: "Quy chuẩn đánh giá",
  cscore_drawer_qt_dqt: "Điểm quan trắc định kỳ",
  cscore_drawer_qt_dqtct: "Điểm quan trắc công trình",
  cscore_drawer_qt_tqtn: "Vị trí quan trắc",
  cscore_drawer_qt_batch: "Đợt quan trắc",
  cscore_drawer_qt_mqt: "Mẫu quan trắc định kỳ",
  cscore_drawer_qt_mqtct: "Mẫu quan trắc công trình",
  cscore_drawer_qt_chtdt: " Cấu hình thông số quan trắc",
  cscore_drawer_qt_chtstc: " Cấu hình thông số quy chuẩn",
  cscore_drawer_qt_ktqt: "Đánh giá kết quả quan trắc nước",
  cscore_drawer_qt_dlqtdk:"Dữ liệu quan trắc định kỳ",
  cscore_drawer_qt_chts:"Cấu hình thông số",
  cscore_drawer_dlqt_nm:"Nước mặt",
  cscore_drawer_dlqt_ndd:"Nước dưới đất",
  cscore_drawer_dlqt_nxt:"Nước xả thải",
  cscore_drawer_dlqt_kt:"Khí tượng",
  cscore_drawer_dlqt_tv:"Thủy văn",
  cscore_drawer_dlqt_kknt:"KK ngoài trời, tiếng ồn, độ rung",
  cscore_drawer_dlqt_to:"Tiếng ồn",
  cscore_drawer_dlqt_dr:"Độ rung",
  cscore_drawer_dlqt_nb:"Nước biển",
  cscore_drawer_dlqt_m:"Nước mưa",
  cscore_drawer_dlqt_kthai:"Khí thải",
  cscore_drawer_dlqt_d:"Đất",
  cscore_drawer_dlqt_tt:"Trầm tích",

  cscore_drawer_dlqt_dk:"Dữ liệu quan trắc định kỳ",
  cscore_drawer_qtvhl:"Quan trắc Vịnh Hạ Long",



  cscore_drawer_qtkttv_tnn: "Quan trắc khí tượng thủy văn",
  cscore_drawer_qtkttv_qtkt: "Thông số quan trắc khí tượng",
  cscore_drawer_qtkttv_qttv: "Thông số quan trắc thủy văn",
  cscore_drawer_qtkttv_tqt: "Vị trí quan trắc",
  cscore_drawer_qtkttv_kqt: "Kỳ quan trắc",
  cscore_drawer_qtkttv_ktqt: "Kết quả quan trắc KTTV",
  cscore_drawer_qtkttv_tsqt: "Cấu hình thông số quan trắc KTTV",
  

  cscore_drawer_categories: "Danh mục",
  cscore_drawer_categories_qlvb: "Loại văn bản",
  cscore_drawer_categories_qlkcn: "Khu công nghiệp",
  cscore_drawer_categories_qlct: "Đơn vị quản lý công trình",
  cscore_drawer_categories_qldv: "Tổ chức/cá nhân được cấp phép",
  cscore_drawer_categories_qlln: "Làng nghề",
  cscore_drawer_categories_qlnm: "Nhà máy",

  cscore_drawer_map: "Bản đồ",
  cscore_drawer_map_tnn: " Bản đồ tra cứu", 

  cscore_drawer_bctk: "Báo cáo thống kê",
  cscore_drawer_log: "Nhật ký hệ thống",
  cscore_drawer_water_construction: "Công trình nước mặt",
  cscore_drawer_statistic: "Báo cáo thống kê",



  // Login
  cscore_login_user_name: "Tài khoản",
  cscore_login_password: "Mật Khẩu",
  cscore_login_repassword: "Nhập lại mật khẩu",
  cscore_login_sign_in: "Đăng Nhập",
  cscore_forgot_password: "Quên Mật Khẩu",
  cscore_forgot_password_reset: "Mật khẩu mới",
  cscore_login_required_user_name: "Tài khoản là bắt buộc",
  cscore_login_required_func_name: "Tên là bắt buộc",
  cscore_login_required_password: "Mật khẩu là bắt buộc",
  cscore_login_min: "Tên đăng nhập ít nhất 6 ký tự",
  cscore_login_max: "Mật khẩu nhiều nhất là 30 ký tự",
  cscore_login_create_account: "Thêm mới người dùng",
  cscore_login_create_function: "Thêm mới chức năng",
  cscore_re_password: "Nhập lại mật khẩu",
  cscore_old_password: "Mật khẩu hiện tại",
  cscore_dia_chi_doanh_nghiep: "Địa chỉ doanh nghiệp",
  //Input
  cscore_input_pladceholder: "Nhập",
  cscore_input_pladceholder_account: "Nhập tài khoản",
  cscore_input_pladceholder_password: "Nhập mật khẩu",
  cscore_input_pladceholder_name: "Nhập họ và tên",
  cscore_input_pladceholder_phone: "Nhập số điện thoại",
  cscore_input_pladceholder_email: "Nhập email",
  cscore_input_pladceholder_andress: "Nhập địa chỉ",
  cscore_input_pladceholder_object: "Chọn đối tượng quan trắc",
  cscore_create_modal: "Thêm mới",
  cscore_input_pladceholder_cascader: "Chọn",
  cscore_input_name: "Họ và tên",
  cscore_input_CV: "Chức vụ",
  cscore_input_functionName: "Tên chức năng",
  cscore_input_description: "Mô tả",
  cscore_input_App: "Ứng dụng",
  cscore_input_LinhVuc: "Lĩnh vực",
  cscore_input_PB: "Phòng ban",
  cscore_input_Module: "Module",
  cscore_input_company: "Cơ quan quản lý",
  cscore_input_phone: "Điện thoại",
  cscore_input_email: "Email",
  cscore_input_address: "Địa chỉ",
  cscore_input_Required: "Không được để trống",
  cscore_input_min: "Nhập ít nhất 5 ký tự",
  cscore_input_max: "Nhập nhiều nhất là 30 ký tự",
  cscore_boloc: "Bộ lọc",
  cscore_agency: "Tên cơ quan",
  cscore_coquanraquyetdinh: "Cơ quan ra quyết định",
  cscore_describe: "Mô tả",
  cscore_fax: "Fax",
  cscore_website: "Website",
  cscore_agency_code: "Mã cơ quan",
  cscore_unit_code: "Mã đơn vị",
  cscore_create_agency: "Thêm mới cơ quan",
  cscore_info_agency: "Thông tin cơ quan",
  cscore_linh_vuc: "Tên lĩnh vực",
  cscore_linh_vuc_code: "Mã lĩnh vực",
  cscore_create_linh_vuc: "Thêm mới lĩnh vực",
  cscore_info_linh_vuc: "Thông tin lĩnh vực",
  cscore_create_lv: "Thêm mới lĩnh vực",
  cscore_create_pb: "Thêm mới phòng ban",
  cscore_phong_ban: "Tên phòng ban",
  cscore_phong_ban_code: "Mã phòng ban",
  cscore_info_phong_ban: "Thông tin phòng ban",
  cscore_create_cv: "Thêm mới chức vụ",
  cscore_chuc_vu: "Tên chức vụ",
  cscore_chuc_vu_code: "Mã chức vụ",
  cscore_info_chuc_vu: "Thông tin chức vụ",
  cscore_create_Api: "Thêm mới Api",
  cscore_Api_name: "Tên Web Api",
  cscore_info_Api: "Thông tin Api",
  cscore_api_name_in: "Tên hệ thống",
  cscore_group_name: "Nhóm người dùng",
  cscore_add_group: "Thêm mới nhóm người dùng",
  cscore_info_app: "Thông tin ứng dụng hệ thống",
  cscore_dich_vu: "Tên dịch vụ",
  cscore_status: "Trạng thái",
  cscore_info_khonggian: "Thông tin CSDL không gian",
  cscore_search_place_holder: "Nhập thông số ...",
  cscore_ten_doanh_nghiep: "Tên doanh nghiệp",
  cscore_ftp: "Danh mục FTP",
  cscore_info_ftp: "Thông tin ftp",
  cscore_tencutri: "Tên người phản ánh",
  cscore_doanh_nghiep: "Doanh nghiệp",

  cscore_BDnen: "Danh mục bản đồ nền",
  cscore_info_BDnen: "Thông tin bản đồ nền",
  cscore_stt: "STT",
  cscore_number_input: "Chỉ được nhập kí tự số",
  cscore_pladceholder_doanhnghiep: "Nhập doanh nghiệp",
  //Buttons
  cscore_back: "Quay lại",
  cscore_save: "Lưu",
  cscore_savecauhinhdonvi: "Lưu cấu hình đơn vị",
  cscore_update: "Cập nhật",
  cscore_btn_add: "Thêm mới",
  cscore_exit: "Thoát",
  cscore_next: "Tiếp tục",
  cscore_thiet_lap_mau: "Thiết lập mẫu",
  // Common
  cscore_cancel: "Hủy",
  cscore_collections: "Bộ sưu tập",
  cscore_components: "Components",
  cscore_submit: "Lưu",
  cscore_required: "Thông tin bắt buộc",
  cscore_validate_number: "Trường thông tin số",
  cscore_name: "Tên",
  cscore_note: "Ghi chú",
  cscore_cors: "Cors",
  cscore_api: "API",
  cscore_code: "Nhập code",
  cscore_code_name: "Code",
  cscore_login: "Đăng nhập",
  cscore_logout: "Đăng xuất",
  cscore_field: "Lĩnh vực",
  cscore_search: "Tìm kiếm",
  cscore_application: "Ứng dụng",
  cscore_function: "Chức năng",
  cscore_pladceholder_group: "Chọn nhóm",
  cscore_unauthorized: "Người dùng chưa xác thực",
  cscore_cscore_tnn: "Hệ thống quản lý tài nguyên nước",
  cscore_tai_nguyen_nuoc: "Tài nguyên nước",
  cscore_dtm: "ĐTM",
  cscore_common_info: "Thông tin chung",
  cscore_thanh_tra_info: "Kết quả thanh tra",
  cscore_ct_info: "Thông tin công trình",
  cscore_ketQuaGP: "Kết quả giấy phép",
  cscore_organization: "Tên tổ chức",
  cscore_dkkd_qdtl: "Số ĐKKD/QĐTL",
  cscore_ngay_cap: "Ngày cấp",
  cscore_noi_cap: "Nơi cấp",
  cscore_phone: "Số điện thoại",
  cscore_email: "Địa chỉ email",
  cscore_representative: "Người đại diện",
  cscore_owner_representative: "Đại diện chủ sở hữu",
  cscore_profile_user: "Thông tin người dùng",
  cscore_profile_change_password: "Đổi mật khẩu",
  cscore_hdsd: "Hướng dẫn sử dụng",

  //home
  cscore_app: 'Ứng dụng',
  cscore_admin: 'QTHT',
  cscore_tnn: 'TNN',
  cscore_quantrac: "QUAN TRẮC",
  cscore_nameApp: 'Hệ thống quản lý, cập nhật CSDL quan trắc môi trường',
  cscore_dashboard: 'MAIN',
  // bao cao phe duyet
  cscore_draw_bcpd: "Báo cáo phê duyệt",
  cscore_add_bcpd:"Thêm mới báo cáo phê duyệt",
  cscore_ql_duan: "Quản lý dự án",
  cscore_tt_duan: "Dự án",
  cscore_add_duan: "Thêm mới dự án",
  cscore_edit_duan: "Sửa thông tin dự án",
  cscore_dia_chi_du_an: "Địa chỉ dự án",
  cscore_edit_bcpd:"Sửa báo cáo phê duyệt",
  cscore_input_coquancap:"Cơ quan cấp",
  cscore_select_loaipheduyet:"Loại hình phê duyệt",
  cscore_input_soqdcu: "Số quyết định cũ",
  cscore_input_ngayqdcu:"Ngày quyết định cũ",
  cscore_inout_truluongkt:"Trữ lượng khai thác",
  cscore_input_cskt:"Công suất thiết kế",
  cscore_input_tenduan_ten:"Tên dự án",
  cscore_input_phamviquymo:"Phạm vi quy mô",
  cscore_title_hangmucduan:"Hạng mục dự án",
  cscore_input_dientich:"Diện tích",
  cscore_title_detail_ttc:"Thông tin chung",
  cscore_donvitruluong:"Trữ lượng khai thác đơn vị",
  cscore_coongsuatkt:"Công suất thiết kế đơn vị",
  cscore_title_detail: "Thông tin dự án",
  cscore_title_detail_hm:"Thông tin hạng mục dự án",
  cscore_input_tenhangmucduan:"Tên hạng mục dự án",
  cscore_truwluong:"Trữ lượng",
  cscore_congsuat:"Công suất",
  cscore_hieuluctunam:"Có hiệu lực từ năm",
  cscore_cohieulucdennam:"Có hiệu lực đến năm",
  cscore_title_detail_ttqd:"Thông tin quyết định",
  cscore_tunam: "Từ năm",
  cscore_dennam: "Đến năm",
  // QT vinh ha long

  cscore_draw_qtvinhhalong:"Quan trắc Vịnh Hạ Long",
  
  // de an chi tiet

  cscore_add_dact:" Thêm mới đề án",
  cscore_edit_dact:"Sửa đề án",
  // quyet dinh phe duyet nuoi trong thuy san
  cscore_draw_ntts:"Quyết định ban hành",
  cscore_add_qdpd:"Thêm mới quyết định ban hành",
  cscore_eidt_qdpd:"Sửa quyết định ban hành",
  cscore_title_tcnd:"Tra cứu doanh nghiệp",
  // Status
  cscore_Activated: "Kích hoạt",
  cscore_Deactivated: "Không kích hoạt",
  cscore_Banned: "Bị khoá",

  // water_construction
  cscore_hydropower: "Thủy điện",
  cscore_reservoir: "Quản lý hồ chứa",
  cscore_pump_station: "Quản lý trạm bơm",
  cscore_bai_dap: "Quản lý bai đập",
  //Kqgqkn
  cscore_nguoi_Tra_Loi: "Người trả lời",
  cscore_thang:"Tháng",
  cscore_chonthang:"Chọn tháng",
  cscore_nam: "Năm",
  cscore_noidungkiennghi:"Nội dung phản ánh",
  cscore_noidungtraloi:"Nội dung trả lời",
  cscore_noidung: "Nội dung",
  //HoChua
  cscore_maCongTrinh: 'Ký hiệu công trình',
  cscore_ho_chua: 'Hồ chứa',
  cscore_hoChua: 'Hồ chứa',
  cscore_caoTrinhDinhDap: 'Cao trình đỉnh đập (m)',
  cscore_chieuCaoDap: 'Chiều cao đập (m)',
  cscore_chieuDaiDap: 'Chiều dài đập (m)',
  cscore_chieuRongDap: 'Chiều rộng đập (m)',
  cscore_congSuatDamBaoPhat: 'Công suất đảm bảo phát (MW)',
  cscore_congSuatLapMayPhatDien: 'Công suất máy phát điện (MW)',
  cscore_dienLuongBinhQuan: 'Điện lượng bình quân (MW)',
  cscore_dienTichLuuVuc: 'Diện tích lưu vực (ha)',
  cscore_dienTichNuoiTrong: 'Diện tích nuôi trồng  (ha)',
  cscore_dienTichTuoiThietKe: 'Diện tích tưới thiết kế  (ha)',
  cscore_dungTich: 'Dung tích (Triệu m3)',
  cscore_dungTichChet: 'Dung tích chết (Triệu m3)',
  cscore_dungTichCuoiMuaLu_DauMuaCan: 'Dung tích cuối mùa lũ - đầu mùa cạn (triệu m3)',
  cscore_dungTichHuuIch: 'Dung tích hữu ích (triệu m3)',
  cscore_dungTichPhongLu: 'Dung tích phòng lũ (triệu m3)',
  cscore_dungTichToanBo: 'Dung tích toàn bộ (triệu m3)',
  cscore_hienTrangCongTrinh: 'Hiện trạng công trình',
  cscore_hinhThucTranXaLu: 'Hình thức tràn xả lũ',
  cscore_luuLuongPhatDienTK: 'Lưu lượng phát điện thiết kế (m3/s)',
  cscore_mucNuocDangGiaCuong: 'Mực nước dâng gia cường (m)',
  cscore_quyTrinhVanHanh: 'Quy trình vận hành',
  cscore_quyTrinhVanHanhDap: 'Quy trình vận hành đập',
  cscore_soCuaLayNuoc: 'Số cửa lấy nước',
  cscore_soHoCapNuoc: 'Số hồ cấp nước',
  cscore_mdsdluuluong: "Lưu lượng",
  // song: 'Sông',
  cscore_soToMay: 'Số tổ máy',
  cscore_tenLuuVucSong: 'Tên lưu vực sông',
  cscore_thoiGianKT: 'Thời gian khai thác',
  cscore_lichsu: "Lịch sử phê duyệt",
  //TramBom
  cscore_tramBom: 'Trạm bơm',
  cscore_congSuatMayBom: 'Công suất máy bơm',
  cscore_dienTichTuoiThucTe: 'Diện tích tưới thực tế',
  cscore_luuLuongKhaiThac: 'Lưu lượng khai thác (m3/ngày.đêm)',
  cscore_luuLuongKT: 'Lưu lượng khai thác (m3/h)',
  cscore_luuLuongThietKe: 'Lưu lượng thiết kế (m3/s)',
  cscore_luuLuongThucTe: 'Lưu lượng thực tế (m3/s)',
  cscore_soMayBom: 'Số máy bơm',
  cscore_thoiGianKhaiThac: 'Thời gian khai thác',
  cscore_mucDichSuDung: 'Mục đích sử dụng',
  cscore_mucDichKTSD: 'Mục đích khai thác sử dụng',

  //bai dap
  cscore_mucDichSD: 'Mục đích sử dụng',
  cscore_nguonNuocKTSD: 'Nguồn nước khai thác sử dụng',
  cscore_luongNuocKhaiThac: 'Lượng nước khai thác, sử dụng',
  cscore_phuongThucKhaiThac: 'Phương thức khai thác',
  cscore_chieuCao: 'Chiều cao',
  cscore_chieuDai: 'Chiều dài',
  cscore_chieudaikm: 'Chiều dài(Km)',
  cscore_chieuRong: 'Chiều rộng',
  cscore_dienTichTuoiTK: 'Diện tích nuôi thiết kế',
  cscore_baiDap: 'Bai đập',

  //cong
  cscore_cong: 'Cống',
  cscore_caoTrinhCotNuocTK: 'Cao trình cột nước thiết kế',
  cscore_dienTichThietKe: 'Diện tích thiết kế (ha)',
  cscore_dienTichThucTe: 'Diện tích thực tế (ha)',
  cscore_dienTichTieuThietKe: 'Diện tích tiêu thiết kế (ha)',
  cscore_dienTichTieuThucTe: 'Diện tích tiêu thực tế (ha)',
  cscore_duongKinh: 'Đường kính',
  cscore_soCua: 'Số cửa',
  cscore_trenBo: 'Trên bờ',
  cscore_caoTrinhDayCong: 'Cao trình đầy cống',
  cscore_tenKenh: 'Tên kênh',
  cscore_theo_km_de: 'Theo km đê',
  cscore_tuyen_de: 'Tuyến đê',
  //TramCapNuoc
  cscore_TramCapNuoc: 'Trạm cấp nước',
  cscore_congSuatMayBomThietKe: 'Công suất máy bơm thiết kế',
  cscore_congSuatMayBomThucTe: 'Công suất máy bơm thực tế',
  cscore_dienTichTK: 'Diện tích thiết kế (ha)',
  cscore_luuLuongTK: 'Lưu lượng thiết kế (m3/s)',
  cscore_capNuoc: 'Câp nước',
  cscore_soHo: 'Số hồ',
  cscore_soHoThucCap: 'Số hồ thực cấp',
  cscore_thongSoCongTrinh: 'Thông số công trình',

  //NhaMayNuoc
  cscore_NhaMayNuoc: 'Nhà máy nước',

  //CongTrinhXaThai
  cscore_CongTrinhXaThai: 'Công trình xả thải',
  cscore_luuLuongNuocThai: 'Lưu lượng nước thải (m3/ngày.đêm)',
  cscore_luuLuongNuocThaiLonNhat: 'Lưu lượng nước thải lớn nhất (m3/ngày.đêm)',
  cscore_luuLuongXaTrungBinh: "Lưu lượng xả trung bình (m3/s)",
  cscore_luuLuongXaLonNhat: "Lưu lượng xả lớn nhất (m3/ngày.đêm)",
  cscore_soDiemXa: 'Số điểm xả',
  cscore_cheDoXaThai: 'Chế độ xả',
  cscore_loaiHinhNuocThai: 'Loại hình nước thải',
  cscore_donViThamDinh:'Đơn vị thẩm định',
  cscore_nguonTiepNhan: 'Nguồn tiếp nhận',
  cscore_chonnguontiepnhan: 'Chọn nguồn tiếp nhận',
  cscore_phuongThucXaThai: 'Phương thức xả thải',
  cscore_quyChuanApDung: 'Quy chuẩn áp dụng',
  cscore_quyChuanVN: 'Quy chuẩn Việt Nam',
  cscore_cotAB: 'Cột A/B',
  cscore_heSoK: 'Hệ số K',
  cscore_thuocLuuVucSong: 'Thuộc lưu vực sông',
  cscore_diemXaThai: 'Điểm xả thải',
  cscore_diem_xa_nươc_thai: "Điểm xả thải vào nguồn nước",
  cscore_soHieu: 'Số hiệu',
  cscore_caoDo: 'Cao độ',
  cscore_themDiemXaThai: 'Thêm điểm xả thải',
  cscore_capNhatDiemXaThai: 'Cập nhật điểm xả thải',
  cscore_thongtindiemxathai: "Thông tin điểm xả thải",
  cscore_laKieuSo: ' là kiểu sô',
  cscore_laKieuSoThapPhan: " là kiểu số thập phân",

  //CongTrinhNuocDuoiDat
  //KhaiThac
  cscore_KhaiThac: 'Khai thác',
  cscore_ThamDo: 'Thăm dò',
  cscore_tongLuongKhaiThac: 'Tổng lượng nước khai thác (m3/ngày.đêm)',
  cscore_soGieng: 'Số giếng',
  cscore_tongSoGieng: 'Tổng số giếng',
  cscore_gieng: 'Giếng',
  cscore_chieuSauMucNuoc: 'Chiều sâu mực nước',
  cscore_chieuSauMucNuocTinh: 'Chiều sâu mực nước tĩnh (m)',
  cscore_mnTinh: 'Tĩnh (m)',
  cscore_chieuSauMucNuocDong: 'Chiều sâu mực nước lớn nhất cho phép (m)',
  cscore_mnDong: 'Động (m)',
  cscore_tangChuaNuocKhaiThac: 'Tầng chứa nước khai thác',
  cscore_chieuSauGieng: 'Chiều sâu giếng (m)',
  cscore_chieuSauDoanThuNuoc: 'Chiều sâu đoạn thử nước từ',
  cscore_chieuSauDoanThuNuocTu: 'Chiều sâu đoạn thử nước từ (m)',
  cscore_mnTu: 'Từ (m)',
  cscore_chieuSauDoanThuNuocDen: 'Chiều sâu đoạn thử nước đến (m)',
  cscore_mnDen: 'Đến (m)',
  cscore_cheDoKhaiThac: 'Chế độ khai thác',
  cscore_toaDo: 'Tọa độ',
  cscore_toaDo_palceholder: 'x,y',
  cscore_diemKhaiThac: 'Điểm khai thác',
  cscore_chieuSauDatOngLoc: 'Chiều sâu đặt ống lọc (m)',
  cscore_chieuSauMucNuocDongMax: 'Chiều sâu mức nước đóng lớn nhất (m)',
  cscore_loaiGieng_placeholder: 'Chọn loại giếng',
  cscore_loaiGieng: 'Loại giếng',
  cscore_thuocSong: 'Thuộc sông',
  cscore_thuocLVS: 'Thuộc lưu vực sông',
  cscore_thuocHC: 'Thuộc hồ chứa',
  //ThamDo
  cscore_thamDo: "Thăm dò",
  cscore_mucDichThamDo: "Mục đích thăm dò",
  cscore_giengThamDo: 'Giếng thăm dò',
  cscore_dienTichThamDo: 'Diện tích thăm dò (ha)',
  cscore_tongLuongThamDo: 'Tổng lượng thăm dò (m3)',
  cscore_tangChuaNuocThamDo: 'Tầng chứa nước thăm dò',
  cscore_luuLuongThamDo: 'Lưu lượng thăm dò',

  //LuuLuongKhaiThac
  cscore_congSuatLapMay: 'Công suất lắp máy(MW)',
  cscore_luuLuongMaxQuaNMTD: `Lưu lượng lớn nhất qua nhà máy thủy điện (m3/s)`,
  cscore_luuLuongLonNhatQuaNMTD: `Lưu lượng lớn nhất qua nhà máy thủy điện (m3/s)`,
  cscore_luuLuongXaDongChayToiThieu: 'Lưu lượng xả dòng chảy tối thiểu (m3/s)',
  cscore_luuLuongXaDongChayMin: 'Lưu lượng xả dòng chảy tối thiểu (m3/s)',

  //statistic
  cscore_statistic_1: "Biểu 01",
  cscore_statistic_2: "Biểu 02",
  //WaterMonitoring
  cscore_sign: "Kí hiệu",
  cscore_parameter: "Thông số",
  cscore_unit: "Đơn vị tính",
  cscore_add_water_moni_para: "Thêm mới thông số quan trắc",
  cscore_edit_moni_param: "Sửa thông số",

  //Applied Standard
  cscore_ma: "Mã",
  cscore_name_standard: "Tên quy chuẩn",
  cscore_date_issued: "Ngày ban hành",
  cscore_issuing_agency: "Cơ quan phát hành",
  cscore_hieuluc: "Hiệu lực",
  cscore_chonHieuLuc: "Chọn hiệu lực",
  cscore_chonBCDK: "Chọn báo cáo định kỳ",
  cscore_file: "Văn bản đính kèm",
  cscore_applied_standard: "Quản lý quy chuẩn áp dụng",
  cscore_info_applied_standard: "Sửa quy chuẩn",
  cscore_add_applied_standard: "Thêm mới quy chuẩn",
  //action
  cscore_add: "Thêm mới",
  cscore_edit: "Cập nhật",
  cscore_detail: "Chi tiết",

  // Licenses
  cscore_license: "Giấy phép",
  cscore_license_number: "Số giấy phép",
  cscore_license_document: "Tên văn bản",
  cscore_license_agency: "Cơ quan cấp phép",
  cscore_license_organization: "Tổ chức/cá nhân được cấp phép",
  cscore_license_organization_placeholder: "--- Tổ chức/cá nhân được cấp phép ---",
  cscore_license_end_date: "Đến ngày",
  cscore_license_available_date: "Có hiệu lực từ ngày",
  cscore_license_available_end_date: "Có hiệu lực đến ngày",
  cscore_license_available_date_placeholder: "--- Có hiệu lực từ ngày ---",
  cscore_license_period: "Thời hạn (năm)",
  cscore_license_add: "Thêm mới cấp phép",
  cscore_license_edit: "Sửa thông tin cấp phép",
  cscore_license_signed_person: "Người ký",
  cscore_license_signed_date: "Ngày ký",
  cscore_license_position: "Chức vụ",
  cscore_pladceholder_chucvu: "Nhập chức vụ",
  cscore_license_place_received: "Nơi nhận",
  cscore_license_result: "Kết quả xử lý",
  cscore_license_type: "Loại hình giấy phép",
  cscore_license_construction: "Công trình",
  cscore_license_type_construction: "Loại công trình",
  cscore_license_purpose: "Mục đích khai thác",
  cscore_thoiHanGiayPhep: "Thời hạn giấy phép",
  cscore_diaChiDonViXCP: "Địa chỉ tổ chức/cá nhân được cấp phép",
  cscore_nhomCT: "Nhóm công trình",
  cscore_pladceholder_nhomCT: "Chọn nhóm công trình",
  cscore_pladceholder_loaiCT: "Chọn loại công trình",
  cscore_pladceholder_CT: "Chọn công trình",
  cscore_ttkt: "Thanh tra - Kiểm tra",
  cscore_tcqktsd: "Tiền cấp quyền khai thác sử dụng",
  cscore_tenDot: "Tên đợt",
  cscore_tenDonViThucHien : "Tên đơn vị thực hiện",
  cscore_tenTruongDoan : "Tên trưởng đoàn",
  cscore_namThucHien : "Năm thực hiện",
  cscore_soQuyetDinh: "Số quyết định",
  cscore_tendoanhnghiep:"Tên doanh nghiệp",
  cscore_soVanBan: "Số văn bản",
  cscore_tongTien: "Tổng tiền",
  cscore_kttd: "Kiểm tra tọa độ",
  cscore_kiem_tra: "Kiểm tra",
  cscore_cach_tinh_Cmax: "Cách tính Cmax",
  cscore_nam_cap_phep: "Năm cấp phép",
  cscore_nam_het_han: "Năm hết hạn cấp phép",
  cscore_vi_tri_quan_trac: "Vị trí quan trắc",
  // CP CTNM
  cscore_thamSoHC: "Tham số hồ chứa",
  cscore_chatLuongNuocMat: "Chất lượng nước mặt",
  cscore_license_construction_info: "Thông tin công trình",
  cscore_license_hnkndd_info: "Thông tin giấy phép hành nghề",
  cscore_license_working_items: "Thông tin hạng mục ",
  cscore_license_attach_files: "Thông tin tài liệu đính kèm",
  cscore_license_mining_quantity: "Lưu lượng khai thác, sử dụng (m3/s)",
  cscore_license_mining_quantity_day: "Lưu lượng khai thác, sử dụng (m3/ngày đêm)",
  cscore_license_resource: "Nguồn nước khai thác",
  cscore_license_mining_mode: "Chế độ khai thác",
  cscore_license_mining_method: "Phương thức khai thác",
  cscore_license_mining_period: "Thời hạn giấy phép",
  cscore_thoiHanGiaHan: "Thời hạn gia hạn",
  cscore_license_mining_location: "Thông tin vị trí công trình:",
  cscore_noiDungCapLai: "Nội dung cấp lại",
  cscore_soGiayPhepCu: "Số giấy phép cũ",
  cscore_ngayCapPhepCu: "Ngày cấp phép cũ",
  cscore_noiDungDieuChinh: "Nội dung điều chỉnh",
  cscore_thongSoQuanTrac: "Thông số quan trắc",
  cscore_gioiHanThongSo: "Giới hạn thông số",
  cscore_luu_luong_theo_mdktsd: "Lưu lượng theo mục đích khai thác sử dụng",

  // CP_NDD
  cscore_license_underground_mining: "Giấy phép khai thác nước dưới đất",
  cscore_license_underground_scanning: "Giấy phép thăm dò nước dưới đất",
  cscore_license_bang_mdkt: "Mục đích khai thác sử dụng nước",
  cscore_license_bang_ddkt: "Các thông số của công trình cụ thể",
  cscore_capThamQuyen: "Cấp thẩm quyền",
  cscore_thoiHanKT: "Thời hạn khai thác",
  cscore_tongLuongKT: "Tổng lượng nước khai thác (m3/ngày.đêm)",
  cscore_tenMucDich: "Tên mục đích",
  cscore_mucDichKhaiThac: "Mục đích khai thác",
  cscore_luuLuong: "Tổng lượng (m3/ngày.đêm)",
  cscore_quyMoThamDo: "Quy mô thăm dò",

  // CPXT
  cscore_chatLuongNuocThai: "Chất lượng nước thải",
  cscore_tsndNuocThai: "Giới hạn thông số",
  cscore_license_discharge: "Giấy phép xả nước thải",
  cscore_nguonNuocXaSSD: "Nguồn nước tiếp nhận nước xả thải",
  cscore_quyMoHanhNghe: "Quy mô hành nghề",
  cscore_thoiHanHanhNghe: "Thời hạn hành nghề",
  cscore_viTriXaThai: "Vị trí xả thải",
  cscore_heSoKQ: "Hệ số kq",
  cscore_heSoKF: "Hệ số kf",
  cscore_KF: "Kf",
  cscore_KQ: "Kq",
  cscore_tenGiaiDoan: "Tên giai đoạn",
  cscore_loaiThoiHan: "Loại thời hạn",
  cscore_tenThoiHan: "Tên thời hạn",
  cscore_thoiGianTu: "Từ ngày",
  cscore_thoiGianDen: "Đến ngày",
  cscore_toanThoiGian: "Toàn thời gian",
  cscore_tenDiemXT: "Tên điểm xả thải",

  // CP HNKNDD
  cscore_license_hnkndd: "Giấy phép hành nghề khoan nước dưới đẩt",

  // CP CTNB
  cscore_license_seaWaterMining: "Giấy phép khai thác nước biển",

  //CTNM_ThuyDien
  cscore_tenCongTrinh: "Tên công trình",
  cscore_tenDVHC: 'Đơn vị hành chính',
  cscore_hydropower_name: "Tên công trình",
  cscore_hydropower_code: "Ký hiệu công trình",
  cscore_hydropower_place: "Địa điểm",
  cscore_diaDiem: "Địa điểm",
  cscore_province: "Tỉnh/Thành phố",
  cscore_province_placeholder: "Chọn tỉnh",
  cscore_district: "Quận/Huyện",
  cscore_district_placeholder: "Chọn huyện",
  cscore_ward: "Xã/Phường",
  cscore_ward_placeholder: "Chọn xã",
  cscore_donViQuanLy: "Đơn vị quản lý",
  cscore_donViQuanLy_placeholder: "Chọn đơn vị quản lý",
  cscore_nhiemVu: "Mục đích khai thác sử dụng",
  cscore_nguonNuocKhaiThac: "Nguồn nước khai thác",
  cscore_loaiHinhToChuc: "Loại hình tổ chức",
  cscore_namXayDung: "Năm xây dựng",
  cscore_namSuDung: "Năm sử dụng",
  cscore_congSuat: "Công suất (MW)",
  cscore_dungTichHoChua: "Dung tích hồ chứa(Triệu m3)",
  cscore_mucNuocDangBinhThuong: 'Mực nước dâng bình thường (m)',
  cscore_mucNuocCaoNhatTruocLu: 'Mực nước cao nhất trước lũ (m)',
  cscore_mucNuocDonLu: 'Mực nước đón lũ (m)',
  cscore_mucNuocChet: 'Mực nước chết (m)',
  cscore_luuLuongKhaiThacLonNhat: 'Lưu lượng lơn nhất qua nhà máy (m3/ngày.đêm)',
  cscore_luuLuongKhaiThacNhoNhat: 'Lưu lượng nhỏ nhất qua nhà máy (m3/ngày.đêm)',
  cscore_kinhTuyenTruc: 'Kinh tuyến trục(VN2000)',
  cscore_kinhTuyenTrucCap:"Kinh tuyến trục cấp",
  cscore_kinhTuyenTruc_placeholder: 'Kinh tuyến trục',
  cscore_loaiKTT: 'Loại kinh tuyến trục',
  cscore_muiChieu: 'Múi chiếu',
  cscore_muiChieu_placeholder: 'Chọn múi chiếu',
  cscore_ghiChu: 'Ghi chú',
  cscore_key: 'Ký hiệu',
  cscore_themFileDinhkem: 'Thêm tài liệu liên quan',
  cscore_themMultiFileDinhkem: 'Thêm nhiều tài liệu liên quan',
  cscore_capNhatFileDinhkem: 'Cập nhật tài liệu liên quan',
  cscore_themToaDo: 'Thêm tọa độ',
  cscore_capNhatToaDo: 'Cập nhật tọa độ',
  cscore_themHangMuc: 'Thêm hạng mục',
  cscore_capNhatHangMuc: 'Cập nhật hạng mục',
  cscore_hangmuc: 'Hạng mục',
  cscore_themLuuLuongKhaiThac: 'Thêm lưu lượng khai thác',
  cscore_capNhatLuuLuongKhaiThac: 'Cập nhật lưu lượng khai thác',
  cscore_x: 'Tọa độ x',
  cscore_y: 'Tọa độ y',
  cscore_coordinate: 'Tọa độ',
  cscore_toaDoCongTrinh: 'Tọa độ công trình',

  // Hang muc
  cscore_work_item_name: "Tên hạng mục",
  cscore_work_item_coordinateX: "Tọa độ X",
  cscore_work_item_coordinateY: "Tọa độ Y",
  cscore_hangMucCongTrinh: 'Hạng mục công trình',

  //FileDinhkem
  cscore_fileDinhkem: 'Tài liệu liên quan',
  cscore_fileTaiLieu: 'File tài liệu',
  cscore_tenTaiLieu: 'Tên tài liệu',
  cscore_soTaiLieu: 'Số tài liệu',
  cscore_ngayKy: 'Ngày ký',

  // LNKT
  cscore_quantity_capacity: "Công suất lắp máy",
  cscore_quantity_maximum_flowing: "Lưu lượng lớn nhất qua NMTĐ (m3/s)",
  cscore_quantity_maximum_mining: "Lưu lượng khai thác lớn nhất (m3/s)",
  //Tram Qt 
  cscore_tramQTTnn: "Quản lý vị trí quan trắc",
  cscore_pladceholder_tramQT: "Chọn vị trí quan trắc",
  cscore_pladceholder_kyQT: "Chọn kỳ quan trắc",
  cscore_add_tramQT: "Thêm mới vị trí quan trắc",
  cscore_edit_tramQT: "Sửa vị trí quan trắc",
  cscore_tramQT_KTTV: "Quản lý vị trí quan trắc khí tượng thủy văn",
  cscore_add_tramQT_KTTV: "Thêm mới vị trí quan trắc",
  cscore_edit_tramQT_KTTV: "Sửa vị trí quan trắc",
  cscore_info_tram_qt: "Thông tin vị trí quan trắc",
  cscore_hang_tram: "Hạng trạm",
  cscore_kinh_tuyen_truc: "Kinh tuyến trục",
  cscore_dm_kinh_tuyen_truc: "Danh mục kinh tuyến trục",
  cscore_add_kinh_tuyen_truc_TW: "Thêm kinh tuyến trục cấp trung ương",
  cscore_add_kinh_tuyen_truc_DP: "Thêm kinh tuyến trục cấp địa phương",
  cscore_edit_kinh_tuyen_truc: "Sửa kinh tuyến trục",
  cscore_cap: "Cấp",
  cscore_chon_cap: "Chọn cấp",
  cscore_do: "Độ",
  cscore_phut: "Phút",
  cscore_so_gieng: "Số giếng",
  cscore_so_hieu: "Số hiệu",
  cscore_gieng_kt_ndd: "Giếng khai thác nước dưới đất",
  cscore_song: "Sông",
  cscore_ten_DVHC: "Đơn vị hành chính",
  cscore_luu_vuc_song: "Lưu vực sông",
  cscore_ten_tram: "Tên trạm",
  cscore_file_excel: "Nhập file Excel",
  cscore_out_excel: "Xuất file Excel",
  //Qt Tieu chuan danh gia
  cscore_pladceholder_TCAD: "Chọn quy chuẩn áp dụng",
  cscore_TCAD_DG: "Chọn quy chuẩn áp dụng để đánh giá",
  cscore_gioi_han_min: "Giới hạn nhỏ nhất",
  cscore_gioi_han_max: "Giới hạn lớn nhất",
  cscore_phan_loai: "Phân loại",
  cscore_edit_tieu_chuan_danh_gia: "Thông tin quy chuẩn đánh giá",
  cscore_add_tieu_chuan_danh_gia: "Thêm quy chuẩn đánh giá",
  //QT Diem QT
  cscore_ki_hieu_diem: "Ký hiệu điểm",
  cscore_mui_chieu: "Múi chiếu",
  cscore_ten_diem: "Tên điểm",
  cscore_diem_quan_trac: "Quản lý điểm quan trắc định kỳ",
  cscore_add_diem_quan_trac: "Thêm mới điểm quan trắc",
  cscore_edit_diem_quan_trac: "Sửa điểm quan trắc",
  cscore_toa_do: "Tọa độ (X,Y)",
  cscore_pladceholder_diem_qt: "Chọn điểm quan trắc",
  cscore_tuyen_QT: "Tuyến quan trắc",
  cscore_dm_tuyen_qt: "Quản lý tuyến quan trắc",
  cscore_name_tuyen_qt: "Tên tuyến quan trắc",
  cscore_add_tuyen_qt: "Thêm tuyến quan trắc",
  cscore_edit_tuyen_qt: "Sửa tuyến quan trắc",
  cscore_diem_quan_trac_CT: "Quản lý điểm quan trắc công trình",
  cscore_add_diem_quan_trac_CT: "Thêm mới điểm quan trắc công trình",
  cscore_edit_diem_quan_trac_CT: "Sửa điểm quan trắc công trình",
  cscore_inp_diem_qt: "Điểm quan trắc",
  cscore_inp_dot_qt: "Đợt quan trắc",
  //QT Dot QT
  cscore_dot_quan_trac: "Quản lý đợt quan trắc",
  cscore_add_dot_quan_trac: "Thêm mới đợt quan trắc",
  cscore_edit_dot_quan_trac: "Sửa đợt quan trắc",
  cscore_name_dot_quan_trac: "Tên dợt quan trắc",
  cscore_time_start: "Ngày bắt đầu",
  cscore_time_end: "Ngày kết thúc",
  cscore_ke_hoach_QT: "Kế hoạch quan trắc",
  cscore_noi_dung_QT: "Nội dung quan trắc",
  cscore_don_vi_thuc_hien: "Đơn vị thực hiện",
  cscore_dm_don_vi_TH: "Danh mục đơn vị thực hiện",
  cscore_add_don_vi_TH: "Thêm mới đơn vị",
  cscore_edit_don_vi_TH: "Sửa đơn vị",
  cscore_name_don_vi_TH: "Tên đơn vị",
  cscore_pladceholder_dot_QT: "Chọn đợt quan trắc",
  //Cấu hình thông số quan trắc

  //Mẫu quan trắc
  cscore_mau_quan_trac: "Quản lý mẫu quan trắc định kỳ",
  cscore_mau_quan_trac_CT: "Quản lý mẫu quan trắc công trình",
  cscore_sample_name: "Tên mẫu",
  cscore_ngay_lay_mau: "Ngày lấy mẫu",
  cscore_nguoi_lay_mau: "Người lấy mẫu",
  cscore_nguoi_giam_sat: "Người giám sát",
  cscore_ngay_phan_tich: "Ngày phân tích",
  cscore_ngay_nhan_mau: "Ngày nhận mẫu",
  cscore_ket_qua_QT: "Kết quả quan trắc",
  cscore_ds_ket_qua_qt: "Danh sách kết quả quan trắc",
  cscore_value: "Giá trị",
  cscore_don_vi: "Đơn vị",
  cscore_add_mau_QT: "Thêm mới mẫu quan trắc",
  cscore_edit_mau_QT: "Sửa mẫu quan trắc",
  cscore_info_mau_QT: "Số liệu",
  cscore_add_mau_QT_CT: "Thêm mẫu quan trắc công trình",
  cscore_edit_mau_QT_CT: "Sửa mẫu quan trắc công trình",
  cscore_pladceholder_mau_QT: "Chọn mẫu quan trắc",
  cscore_danh_gia: "Đánh giá",
  cscore_danh_gia_QT: "Đánh giá kết quả quan trắc nước",
  cscore_danh_gia_QT_CT: "Đánh giá kết quả quan trắc công trình",
  cscore_chua_danh_gia: "Chưa đánh giá",
  cscore_phuong_phap_LM: "Phương pháp lấy mẫu",
  cscore_name_Phuong_phap_LM: "Tên phương pháp",
  cscore_DM_PP_LM: "Quản lý phương pháp lấy mẫu",
  cscore_add_PP: "Thêm phương pháp",
  cscore_edit_PP: "Sửa phương pháp",
  cscore_phuong_phap_PT: "Phương pháp phân tích",
  cscore_DM_PP_PT: "Quản lý phương pháp phân tích",
  cscore_doi_tuong_quan_trac: "Đối tượng quan trắc",
  cscore_hien_trang_moi_truong_nm: "Hiện trạng môi trường nước mặt",
  cscore_hien_trang_moi_truong_ndd: "Hiện trạng môi trường nước dưới đất",
  cscore_hien_trang_moi_truong_xt: "Hiện trạng môi trường nước xả thải",
  cscore_hien_trang_moi_truong_kknt: "Hiện trạng môi trường không khí ngoài trời",
  cscore_hien_trang_moi_truong_to: "Hiện trạng môi trường tiếng ồn",
  cscore_hien_trang_moi_truong_dr: "Hiện trạng môi trường độ rung",
  cscore_hien_trang_moi_truong_nb: "Hiện trạng môi trường nước biển",
  cscore_hien_trang_moi_truong_m: "Hiện trạng môi trường nước mưa",
  cscore_hien_trang_moi_truong_kt: "Hiện trạng môi trường khí thải",
  cscore_hien_trang_moi_truong_d: "Hiện trạng môi trường đất",
  cscore_hien_trang_moi_truong_tt: "Hiện trạng môi trường trầm tích",
  cscore_moi_truong: "Môi trường",

  //Thong so quan trac khi tuong
  cscore_khi_tuong_QT: "Quản lý thông số quan trắc khí tượng",
  cscore_add_khi_tuong_QT: "Thêm thông số quan trắc khí tượng",
  cscore_edit_thong_so_khi_tuong: "Sửa thông số quan trắc khí tượng",
  cscore_QT_khi_tuong: "Quan trắc khí tượng",
  cscore_nuoc_mat: "Nước mặt",
  cscore_nuoc_duoi_dat: "Nước dưới đất",
  cscore_nuoc_xa_thai: "Nước xả thải",
  //Thong so quan trac thuy van
  cscore_thuy_van_QT: "Quản lý thông số quan trắc thủy văn",
  cscore_add_thuy_van_QT: "Thêm thông số quan trắc thủy văn",
  cscore_edit_thong_so_thuy_van: "Sửa thông số quan trắc thủy văn",
  cscore_QT_thuy_van: "Quan trắc thủy văn",
  //Ky quan trac
  cscore_ky_QT: "Tên kỳ",
  cscore_phan_loai_quan_trac: "Chọn loại quan trắc",
  cscore_Loai_quan_trac:"Loại quan trắc",
  cscore_cau_hinh_thong_so_KTTV: "Cấu hình thông số quan trắc khí tượng thủy văn",
  cscore_ky_quan_trac: "Quản lý kỳ quan trắc",
  cscore_add_ky_QT: "Thêm mới kỳ quan trắc",
  cscore_edit_ky_QT: "Sửa kỳ quan trắc",
  //Danh muc
  cscore_DM_Loai_VB: "Danh mục loại văn bản",
  cscore_add_loai_VB: "Thêm mới loại văn bản",
  cscore_edit_loai_vb: "Sửa loại văn bản",
  cscore_ma_vb: "Mã loại văn bản",
  cscore_ten_vb: "Tên loại văn bản",
  cscore_QL_cong_trinh: "Danh mục đơn vị quản lý công trình",
  cscore_Add_QL_cong_trinh: "Thêm mới đơn vị quản lý công trình",
  cscore_Edit_QL_cong_trinh: "Sửa thông tin đơn vị quản lý công trình",
  cscore_co_quan_chu_quan: "Cơ quan chủ quản",
  cscore_co_quan_chu_tri: "Cơ quan chủ trì",
  cscore_khu_cong_nghiep: "Danh mục khu công nghiệp",
  cscore_add_khu_cong_nghiep: "Thêm khu công nghiệp",
  cscore_edit_khu_cong_nghiep: "Sửa thông tin khu công nghiệp",
  cscore_name_khu_cong_nghiep: "Tên khu công nghiệp",
  cscore_key_khu_cong_nghiep: "Mã khu công nghiệp",
  cscore_chu_dau_tu: "Chủ đầu tư",
  cscore_dien_tich: "Diện tích",
  cscore_ngay_sua: "Ngày sửa",
  cscore_ngay_tao: "ngày tạo",
  cscore_nguoi_sua: "Người sửa",
  cscore_nguoi_tao: "Người tạo",
  cscore_qdtl_so: "Quyết định thành lập số",
  cscore_thoi_diem: "Thời điểm",
  cscore_vi_tri: "vị trí",
  cscore_ngay_cap_chung_nhan: "Ngày cấp chứng nhận",
  cscore_noi_cap_chung_nhan: "Nơi cấp chứng nhận",
  cscore_so_chung_nhan: "Số chứng nhận",
  cscore_hien_trang_hoat_dong: "Hiện trạng hoạt động",
  cscore_loai_hinh_san_xuat: "Loại hình sản xuất",
  cscore_lang_nghe_name: "Tên làng nghề",
  cscore_tong_SH_SX_SoHo: "Tổng số hộ sản xuất",
  cscore_version: "Phiên bản",
  cscore_lang_nghe: "Danh mục làng nghề",
  cscore_add_lang_nghe: "Thêm làng nghề",
  cscore_edit_lang_nghe: "Sửa thông tin làng nghề",
  cscore_nha_may: "Danh mục nhà máy",
  cscore_add_nha_may: "Thêm mới nhà máy",
  cscore_edit_nha_may: "Sửa thông tin nhà máy",
  cscore_so_giay_phep: "Số giấy phép",
  cscore_ngay_cap_phep: "Ngày cấp phép",
  cscore_tinh_trang: "Tình trạng",
  cscore_tru_so_chinh: "Trụ sở chính",
  cscore_DKKD_ngay_cap: "Ngày cấp đăng kí kinh doanh",
  cscore_DKKD_noi_cap: "Nơi cấp đăng kí kinh doanh",
  cscore_DKKD_so: "Số đăng kí kinh doanh",
  cscore_CNDT_ngay_cap: "Ngày cấp chứng nhận đầu tư",
  cscore_CNDT_noi_cap: "Nơi cấp chứng nhận đầu tư",
  cscore_CNDT_so: "Số chứng nhận đầu tư",
  cscore_loai_hinh_doanh_nghiep: "Loại hình doanh nghiệp",
  cscore_nam_thanh_lap: "Năm thành lập",
  cscore_NDD_chuc_vu: "Chức vụ người đại diện",
  cscore_NDD_DiaChi: "Địa chỉ người đại diện",
  cscore_NDD_SDD_NgayCap: "Ngày cấp số định danh người đại diện",
  cscore_NDD_SDD_NoiCap: "Nơi cấp số định danh người đại diện",
  cscore_NDD_SDD_So: "Số định danh người đại diện",
  cscore_NDD_SoDienThoai: "Số điện thoại người đại diện",
  cscore_NDD_Ten: "Tên người đại diện",
  cscore_NDD: "Người đại diện",
  cscore_NganhNgheKinhDoanh: "Ngành nghề kinh doanh",
  cscore_QuyMo: "Quy mô",
  cscore_TKNH_ChiNhanh: "Chi nhánh tài khoản ngân hàng",
  cscore_TKNH_So: "Số tài khoản ngân hàng",

  //Ket qua QT KTTV
  cscore_danh_sach_KQ_KTTV: "Quản lý kết quả quan trắc khí tượng thủy văn",
  cscore_add_DS_KQ_KTTV: "Thêm mới kết quả khí tượng thủy văn",
  cscore_edit_DS_KQ_KTTV: "Sửa kết quả khí tượng thủy văn",
  cscore_ngay_QT: "Ngày quan trắc",
  cscore_tooltip_KQQT: "Bạn chưa chọn vị trí quan trắc hoặc kỳ quan trắc",
  cscore_add_KQ_KTTV: "Thêm mới kết quả quan trắc",
  cscore_edit_KQQT: "Sửa kết quả quan tắc",
  //Thông tin công trình bản đồ

  cscore_loaicongtrinh: "Loại công trình",
  cscore_dmloaicongtrinh: "Danh mục loại công trình",
  cscore_addloaicongtrinh: "Thêm mới loại công trình",
  cscore_editloaicongtrinh: "Sửa loại công trình",
  cscore_maloaicongtrinh: "Mã loại công trình",
  cscore_loaigiayphep: "Loại cấp phép",
  cscore_macongtrinh: "Ký hiệu công trình",
  cscore_matramkhit: "",
  cscore_matramthuy: "Mã trạm thủy văn",
  cscore_mucdichsudung: "Mục đích sử dụng",
  cscore_donvithamdinh:"Cơ quan quản lý/ thẩm định",
  cscore_dm_mucdichsudung: "Quản lý mục đích sử dụng",
  cscore_add_mucdichsudung: "Thêm mục đích sử dụng",
  cscore_add_donvithamdinh:"Thêm đơn vị thẩm định",
  cscore_edit_donvithamdinh:"Sửa đơn vị thẩm định",
  cscore_edit_mucdichsudung: "Sửa mục đích sử dụng",
  cscore_name_mucdichsudung: "Tên mục đích",
  cscore_name_donvithamdinh:"Đơn vị thẩm định",
  cscore_namkhaithac: "Năm khai thác",
  cscore_namxaydung: "Năm xây dựng",
  cscore_ngaycapphep: "Ngày cấp phép",
  cscore_sogiayphep: "Số giấy phép",
  cscore_tencongtrinh: "Tên công trình",
  cscore_tendonvicapphep: "Tên đơn vị cấp phép",
  cscore_tendonvixcp: "Tên tổ chức/cá nhân được cấp phép",
// tenhuyen: "huyện Đông Hưng"
// tenxa: "xã Hồng Châu"
  cscore_thoihangiahan: "Thời hạn giấy phép",

  //Don vi tinh
  cscore_don_vi_do: "Đơn vị đo",
  cscore_dm_don_vi_do: "Quản lý đơn vị đo",
  cscore_add_don_vi: "Thêm mới đơn vị đo",
  cscore_edit_don_vi: "Sửa đơn vị đo",
  cscore_name_don_vi: "Tên đơn vị đo",

  //Bieu mau
  cscore_BieuMauSo1: 'Biểu mẫu số 1',
  cscore_BieuMauSo9: 'Biểu mẫu số 9',
  cscore_BieuMauSo10: 'Biểu mẫu số 10',
  cscore_BieuMauSo11: 'Biểu mẫu số 11',
  cscore_BieuMauSo16: 'Biểu mẫu số 16',
  cscore_PhuLuc2: 'Phụ lục 2',
  cscore_PhuLuc3: 'Phụ lục 3',
  cscore_PhuLuc5: 'Phụ lục 5',
  cscore_PhuLuc6: 'Phụ lục 6',
  cscore_xuatFileExcel: 'Xuất file Excel',
  cscore_lamMoi: 'Làm mới',
  cscore_year_placeholder: "Chọn kỳ báo cáo",
  //Thong tin tai nguyen nuoc
  cscore_dm_SVLVS: "Quản lý thông tin sông và lưu vực sông",
  cscore_pladceholder_CapSong: "Chọn cấp sông",
  cscore_pladceholder_Song: "Chọn sông",
  cscore_pladceholder_LuuVuc: "Chọn lưu vực sông",
  cscore_QPPL: "Văn bản quy phạm pháp luật",
  cscore_phan_loai_bao_cao: "Phân loại báo cáo",
  cscore_add_PL_bao_cao: "Thêm mới loại báo cáo",
  cscore_edit_PL_bao_cao: "Sửa loại báo cáo",
  cscore_loai_ban_do: "Loại bản đồ",
  cscore_TNN_duoi_dat: "Đánh giá tài nguyên nước dưới đất",
  cscore_thanh_tra: "Thanh tra",
  cscore_KQ_TT: "Kết quả thanh tra",
  cscore_KQ_KT_DN: "Kết quả kiểm tra từng doanh nghiệp",
  cscore_KQ_KT: "Kết quả kiểm tra",
  cscore_ma_csdl: "Cơ sở dữ liệu",
  cscore_dm_csdl: "Danh mục cơ sở dữ liệu",
  cscore_add_csdl: "Thêm cơ sở dữ liệu",
  cscore_edit_csdl: "Sửa cơ sở dữ liệu",
  cscore_ma_cs_dl: "Mã cơ sở dữ liệu",
  cscore_name_csdl: "Tên cơ sở dữ liệu",
  cscore_bao_cao_name: "Loại báo cáo",
  cscore_add_loai_ban_do: "Thêm mới loại bản đồ",
  cscore_edit_loai_ban_do: "Sửa loại bản đồ",
  cscore_add_QPPL: "Thêm văn bản quy phạm pháp luật",
  cscore_edit_QPPL: "Sửa văn bản quy phạm pháp luật",
  cscore_co_quan_ban_hanh: "Cơ quan ban hành",
  cscore_ngay_hieu_luc: "Ngày có hiệu lực",
  cscore_add_quy_hoach_TNN: "Thêm mới tài liệu quy hạch tài nguyên nước",
  cscore_edit_quy_hoach_TNN: "Sửa thông tin quy hoạch tài nguyên nước",
  cscore_ten_quy_hoach: "Tên báo cáo",
  cscore_nam_thuc_hien: "Năm thực hiện",
  cscore_add_DG_TNN_duoi_dat: "Thêm mới đánh giá ",
  cscore_edit_DG_TNN_duoi_dat: "Sửa đánh giá",
  cscore_dien_tich_dieu_tra: "Diện tích điều tra",
  cscore_tang_chua_nuoc: "Tầng chứa nước",
  cscore_ti_le_dieu_tra: "Tỉ lệ điều tra",
  cscore_vung_dieu_tra: "Vùng điều tra",
  cscore_khu_vuc: "Khu vực",
  cscore_add_DTDG: "Thêm mới báo cáo điều tra đánh giá",
  cscore_edit_DTDG: "Sửa báo cáo điều tra đánh giá",
  cscore_thanh_tra_TNN: "Thanh tra - kiểm tra tài nguyên nước",
  cscore_add_thanh_tra: "Thêm báo cáo quyết định xử phạt vi phạm",
  cscore_edit_thanh_tra: "Sửa báo cáo quyết định xử phạt vi phạm",
  cscore_ten_thanh_tra: "Tên thanh tra",
  cscore_xu_phat: "Xử phạt",
  cscore_DT_thanh_tra: "Đối tượng thanh tra",
  cscore_nam_thanh_tra: "Năm thanh tra",
  cscore_so_tien: "Số tiền",
  cscore_add_bao_cao: "Thêm mới báo cáo",
  cscore_edit_bao_cao: "Sửa báo cáo",
  cscore_add_ban_do: "Thêm mới dữ liệu bản đồ",
  cscore_edit_ban_do: "Sửa dữ liệu bản đồ",
  cscore_ty_le: "Tỷ lệ",
  cscore_ten_ban_do: "Tên bản đồ",
  cscore_pham_vi_thuc_hien: "Phạm vi thực hiện",
  cscore_dm_NKHT: "Nhật ký hệ thống",
  cscore_thongtingieng: "Thông tin giếng",
  cscore_doanhngiepbaocao: "Báo cáo định kỳ",
  cscore_ketquakiennghi:"Kết quả giải quyết kiến nghị cử tri",
  cscore_ketquaphananhbaochi: "Kết quả trả lời phản ánh báo chí",
  cscore_add_kqgqkn:"Thêm mới kết quả giải quyết kiến nghị",
  cscore_edit_kqgqkn:"Sửa kết quả giải quyết kiến nghị",
  cscore_add_kqtlpabc:"Thêm mới kết quả trả lời phản ánh báo chí",
  cscore_edit_kqtlpabc:"Sửa kết quả trả lời phản ánh báo chí",
  cscore_quanlydoanhngiepbaocao: "Quản lý báo cáo định kỳ doanh nghiệp",
  cscore_chonquy: "Chọn quý",
  cscore_chonnam: "Chọn năm",
  cscore_sldoankt: "Số lượng đoàn kiểm tra",
  cscore_ndThanhTra: "Nội dung thanh tra",
  cscore_sldonvixp: "Số lượng đơn vị bị xử phạt",
  cscore_namBaoCao: "Năm báo cáo",
  cscore_quybaocao: "Quý báo cáo",
  cscore_maBaoCao: "Mã báo cáo",
  cscore_noiDungBaoCao: "Nội dung báo cáo",
  cscore_noidungkhacphuc: "Nội dung khắc phục",
  cscore_noidungvipham: "Nội dung vi phạm",
  cscore_sotienxuphat: "Số tiền xử phạt",
  cscore_soluongtochuccanhan: "Số lượng tổ chức cá nhân",
  cscore_quyetDinhPheDuyet: "Quyết định phê duyệt",
  cscore_thoiGianThucHien: "Thời gian thực hiện",
  cscore_thoiGian: "Thời gian",
  cscore_kinhPhi: "Kinh phí",
  cscore_tiencapquyen: "Tiền cấp quyền",
  cscore_tunam: "Từ năm",
  cscore_dennam: "Đến năm",
  cscore_ngayquyetdinh: "Ngày quyết định",
  cscore_namquyetdinh: "Năm quyết định",
  cscore_phuongannoptien: "Phương án nộp tiền",
  cscore_tongsotien: "Tổng số tiền",
  cscore_sotiendathu: "Số tiền đã thu",
  cscore_sotienphaithu: "Số tiền phải thu",
  cscore_tongtienphat: "Tổng tiền phạt",
  cscore_namthu: "Năm thu",
  cscore_themTCQ: "Thêm mới tiền cấp quyền",
  cscore_suaTCQ: "Sửa tiền cấp quyền",
  cscore_tralai: "Trả lại",
  cscore_ngaypheduyet: "Ngày phê duyệt",
  cscore_pheduyet: "Phê duyệt",
  cscore_denghi_capnhat: "Đề nghị cập nhật",
  cscore_tuchoipeduyet:"Từ chối phê duyệt",
  cscore_ngaykiemtra: "Ngày kiểm tra",
  cscore_kq_khac_phuc: "Kết quả khác phục",
  cscore_loi_xu_phat: "Các lỗi chuyển xử phạt",
  cscore_kq_xu_phat: "Kết quả xử phạt",
  cscore_nam: "Năm",
  cscore_dong: "Đóng",
  cscore_delete: "Xóa",
  cscore_danh_sach_bao_cao: "Danh sách báo cáo",
  cscore_muc_dich_su_dung_nuoc: "Mục đích sử dụng nước",
  cscore_ql_muc_dich_su_dung_nuoc: "Quản lý mục đích sử dụng nước",
  cscore_ql_don_vi_tham_dinh:"Quản lý cơ quan quản lý/ thẩm định",
  cscore_ql_loai_hinh_nuoc_thai: "Quản lý loại hình nước thải",
  cscore_add_loai_hinh_nuoc_thai: "Thêm mới loại hình nước thải",
  cscore_edit_loai_hinh_nuoc_thai: "Sửa loại hình nước thải",
  cscore_QD_Nguon_Nuoc_Can_Bao_Ve: "Quyết định nguồn nước cần lập hành lăng bảo vệ",
  cscore_Add_Quyet_Dinh: "Thêm mới quyết định",
  cscore_Edit_Quyet_Dinh: "Sửa quyết định",
  cscore_DM_Quyet_Dinh: "Danh mục quyết định phê duyệt nguồn nước cần lập hành lang bảo vệ",
  cscore_DM_Nguon_Nuoc: "Danh mục nguồn nước",
  cscore_name_nguon_nuoc: "Tên nguồn nước",
  cscore_Add_Nguon_Nuoc: "Thêm mới nguồn nước",
  cscore_Edit_Nguon_Nuoc: "Sửa nguồn nước",
  cscore_Giam_Sat_khai_thac: "Giám sát khai thác sử dụng",
  cscore_Chat_Luong_NDD: "Chất lượng nước dưới đất",
  cscore_duoc_cap_phep: "Được cấp phép khai thác",
  cscore_loai_tram: "Loại trạm",
  cscore_chon_ct_tu_gp_da_co: "Chọn công trình từ giấy phép đã có",

  cscore_vung_kinh_te: "Vùng kinh tế xã hội",
  cscore_dm_vung_kinh_te: "Danh mục vùng kinh tế xã hội",
  cscore_post_vung_kinh_te: "Thêm mới vùng kinh tế",
  cscore_put_vung_kinh_te: "Sửa vùng kinh tế",
  cscore_ma_vung: "Mã vùng",
  cscore_ten_vung: "Tên vùng",

  cscore_dot_bao_cao: "Đợt báo cáo",
  cscore_bao_cao_dinh_ky: "Báo cáo định kỳ",
  cscore_bao_cao_phe_duyet: "Báo cáo phê duyệt",
  cscore_ds_bcdk:"Danh sách báo cáo định kỳ",

  cscore_de_an_chi_tiet: "Đề án",
  cscore_bao_ve_moi_truong: "Thủ tục môi trường khác",
  cscore_hien_trang_moi_truong: "Hiện trạng môi trường",
  cscore_nuoi_trong_thuy_san: "Quan trắc thủy sản",
  cscore_thanh_phan_moi_truong: "Thành phần môi trường",

  cscore_cap_nhat_cap_phep: "Đề nghị cập nhật cấp phép",
  cscore_add_de_nghi: "Thêm mới đề nghị cấp phép",
  cscore_edit_de_nghi: "Sửa đề nghị cấp phép",

  cscore_khong_co_du_lieu_quan_trac: "Không có dữ liệu quan trắc",
  cscore_loading_data: "Đang tải dữ liệu",
  cscore_loading_file: "Đang tải file",

  cscore_dot_quan_trac_number: "Đợt quan trắc số",
  cscore_dot_quan_trac_ten: "Tên đợt quan trắc",
  cscore_cap_nhat_kqqt: "Cập nhật mẫu quan trắc",
  cscore_them_moi_kqqt: "Thêm mới mẫu quan trắc",
  cscore_quyet_dinh_xu_phat_vi_pham: "Quyết định xử phạt vi phạm",
  cscore_convertExcel: "Nhập từ Excel",
  cscore_sheetname: "Tên sheet",
  cscore_dongbatdau: "Dòng bắt đầu",
  cscore_dongketthuc: "Dòng kết thúc",
  cscore_dong_cmax: "Dòng Cmax",
  cscore_cot_mau_kyhieu: "Cột ký hiệu mẫu",
  cscore_cot_mau_ten: "Cột tên mẫu",
  cscore_cot_mau_tinhtrang: "Cột tình trạng mẫu",
  cscore_cot_mau_mota: "Cột mô tả mẫu",
  cscore_cot_donvithuchien: "Cột đơn vị thực hiện",
  cscore_cot_nguoilaymaus: "Cột người lấy mẫu",
  cscore_cot_nguoigiamsats: "Cột người giám sát",
  cscore_cot_ngaylaymau: "Cột ngày lấy mẫu",
  cscore_cot_ngaynhanmau: "Cột ngày nhận mẫu",
  cscore_cot_ngayphantich: "Cột ngày phân tích",
  cscore_cot_dotQuanTracSo: "Cột đợt quan trắc số",
  cscore_cot_dotQuanTrac_Ten: "Cột đợt quan trắc tên",
  cscore_cot_vitriquantrac: "Cột vị trí quan trắc",
  cscore_cot_vitriquantrac_diadiem: "Cột địa điểm vị trí quan trắc",
  cscore_cot_vitriquantrac_x: "Cột tọa độ X",
  cscore_cot_vitriquantrac_y: "Cột tọa độ Y",
  cscore_cot_luuluong: "Cột lưu lượng",
  cscore_cot_nguonnuoc: "Cột nguồn nước KTSD",
  cscore_cot_thongsodautien: "Cột thông số đầu tiên",
  cscore_cot_kyquantrac: "Cột kỳ quan trắc",
  cscore_tai_file_theo_thong_so: "Tải xuống file Excel theo tham số đã thiết lập",
  cscore_download_Excel: "Tải mẫu Excel",
  cscore_convert_Excel: "Chuyển đổi",
  cscore_kyhieuBoQua: "Ký hiệu bỏ qua (kpt, -,...)",
  cscore_kyhieuLonHon: "Ký hiệu lớn hơn",
  cscore_kyHieuNhoHon: "Ký hiệu nhỏ hơn",
  cscore_upload_excel: "Tải tệp lên",
  cscore_congantinh: "Công an tỉnh",
  cscore_input_ngayhethan:"Ngày kết thúc hiệu lực",
  cscore_select_lhnt: "Chọn loại hình nước thải",
  cscore_select_bcdk: "Chọn báo cáo định kỳ",
  cscore_vuot_chi_so: "Vượt chỉ số",
  cscore_trong_nguong: "Bình thường",
  cscore_luu_tam: "Chưa gửi phê duyệt",
  cscore_cho_phe_duyet: "Chờ phê duyệt",
  cscore_khong_phe_duyet: "Đã bị trả lại",
  cscore_binh_luan: "Nội dung trao đổi",
  cscore_lich_su_trao_doi: "Lịch sử trao đổi",
  cscore_gui: "Gửi",
  //
  cscore_tnn_ttcb: "Thông tin cơ bản",
  cscore_tnn_ttbs: "Thông tin bổ sung",
  cscore_tnn_xemlichsuchinhsua:"Xem lịch sử chỉnh sửa",
  cscore_tnn_lichsuchinhsua:"Lịch sử chỉnh sửa",
  cscore_tnn_luutam:"Lưu nháp"
};


export const MESSAGE = {
  CSCORE_LUU:"Lưu thành công",
  CSCORE_ERROR: "Có lỗi xảy ra",
  CSCORE_THERE_IS_NO_DATA: "Không có dữ liệu",
  CSCORE_THERE_IS_SOMETHING_WRONG: "There is something wrong, please try again.",
  cscore_tnn_KHoiPhuc_SUCCESS:"Khôi phục dữ liệu của phiên bản cũ thành công",
  CSCORE_APP_ADD_SUCCESS: "Tạo mới ứng dung thành công",
  CSCORE_APP_ADD_FAILURE: "Tạo mới ứng dung thất bại, có lỗi xẩy ra",
  CSCORE_APP_UPDATE_SUCCESS: "Cập nhật ứng dung thành công",
  CSCORE_APP_UPDATE_FAILURE: "Cập nhật ứng dung thất bại, có lỗi xẩy ra",
  CSCORE_UPDATE_PASSWORD: "Nhập lại mật khẩu không đúng",
  CSCORE_ADD_SUCCESS: "Thêm mới thành công",
  CSCORE_REMOVE_SUCCESS: "Xóa thành công",
  CSCORE_REMOVE_FAILURE: "Lỗi khi xóa",
  CSCORE_USER_ADD_SUCCESS: "Tạo tài khoản thành công",
  CSCORE_USER_UPDATE_SUCCESS: "Cập nhật tài khoản thành công",
  CSCORE_UPDATE_SUCCESS: "Cập nhật thành công",
  CSCORE_UPDATE_FAILURE: "Cập nhật thất bại",
  CSCORE_ADD_FAILURE: "Thêm không thành công",
  CSCORE_UPLOAD_FILE_SUCCESS: 'Upload file thành công',
  CSCORE_UPLOAD_FILE_FAILURE: 'Lỗi khi upload file',
  CSCORE_GET_DATA_SUCCESS: "Lấy dữ liệu thành công",
  CSCORE_GET_DATA_FAILURE: "Lấy dữ liệu thất bại",
  CSCORE_GET_KQQT_FAILURE: "Bạn chưa chọn vị trí quan trắc hoặc kỳ quan trắc",
  CSCORE_GET_LOAI_KQQT_FAILURE: "Bạn chưa chọn loại quan trắc",
  CSCORE_GET_XA: "Bạn chưa chọn xã",
  CSCORE_THONG_SO_TRONG: "Tên thông số không được trống",
  CSCORE_DON_VI_TRONG: "Đơn vị đo không được trống",
  CSCORE_DOI_TUONG_TIEU_CHUAN: "Bạn chưa chọn quy chuẩn áp dụng",
  CSCORE_MAU_QT: "Bạn chưa nhập tên mẫu quan trắc",
  CSCORE_SELECT_MAU_QT: "Bạn chưa chọn mẫu quan trắc",
  CSCORE_DIEM_QT: "Bạn chưa chọn điểm quan trắc",
  CSCORE_DOT_QT: "Bạn chưa chọn đợt quan trắc",
  CSCORE_TRAM_QT: "Bạn chưa chọn vị trí quan trắc",
  CSCORE_KY_QT: "Bạn chưa chọn kỳ quan trắc",
  CSCORE_NGAY_QT: "Ngày quan trắc không được trống",
  CSCORE_MUC_DICH_SU_DUNG: "Bạn chưa chọn mục đích sử dụng",
  CSCORE_NHOM_CONG_TRINH: "Bạn chưa chọn nhóm công trình",
  CSCORE_LOI_CONG_TRINH: "Thông tin công trình bị thiếu",
  CSCORE_CONG_TRINH: "Bạn chưa chọn công trình",
  CSCORE_CONG_TRINH_CAP_PHEP: "Bạn không thể xóa công trình đã được cấp phép",
  CSCORE_TOA_DO_DEM: "Cập nhật thành công nhưng chưa lưu được tọa độ",
  CSCORE_XA_TOA_DO_DIEM: "Xóa thành công nhưng xóa tọa độ thất bại",
  CSCORE_DOI_TUONG_QT: "Bạn chưa chọn đối tượng quan trắc",
  CSCORE_CHON_CAP: "Bạn chưa chọn cấp",
  CSCORE_CHON_TOA_DO: "Bạn phải nhập 3 tọa độ hoặc chỉ nhập 1 tọa độ",
  CSCORE_CHON_NAM_BC: "Bạn chưa chọn năm báo cáo",
  CSCORE_NAM_BD: "Bạn chưa chọn năm bắt đầu",
  CSCORE_NAM_KT: "Bạn chưa chọn năm kết thúc",
  CSCORE_THIEU_TAI_LIEU: "Công trình không có giấy phép",
  CSCORE_KHONG_CO_GIAY_PHEP: "Thiếu file tài liệu đính kèm",
  CSCORE_KHONG_CO_FILE: "Không có file đính kèm",
  CSCORE_PHE_DUYET_THANH_CONG: "Phê duyệt thành công",
  CSCORE_KHONG_CO_DU_LIEU_BAN_DO: "Không có dữ liệu bản đồ",
  CSCORE_KHONG_CO_TOA_DO: "Không có tọa độ",
  CSCORE_CHECKGP: "Giấy phép này đã tồn tại trong hệ thống, không thể tiếp tục thêm mới",
  CSCORE_THIET_LAP_MAU: "Thiết lập mẫu thành công",
  CSCORE_WARNING_THIET_LAP_MAU:"Bạn chưa chọn đơn vị trữ lượng",
  CSCORE_WARNING_THANH_PHAN_MT: "Bạn chưa chọn thành phần môi trường",
  CSCORE_KHONG_CO_QUYEN_TRUY_CAP: "Không có quyền truy cập",
  CSCORE_CHUA_CHON_FILE: "Bạn chưa chọn file Excel để chuyển đổi",
  CSCORE_CHUYEN_DOI_THANH_CONG: "Chuyển đổi Excel thành công",
  CSCORE_WARNING_QUAN_TRAC: "Bạn cần chọn vị trí quan trắc",
  CSCORE_ERROR_THONG_TIN: "Bạn cần nhậm đầy đủ thông tin bị đánh dấu đỏ",
  CSCORE_GUI_PHE_DUYET: "Gửi phê duyệt thành công",
  CSCORE_KHONG_PHE_DUYET: "Đã từ chối phê duyệt",
  CSCORE_GIOI_HAN_THONG_SO: "Chỉ chọn tối đa 2 thông số",
  CSCORE_CHECK_PH: "Giá trị C có dạng a-b (a,b là số và a < b)",
  CSCORE_CHECK_GIATRI: "Giá trị C phải là số",
  CSCORE_DU_LIEU_DOANH_NHGIEP_TRONG: "Dữ liệu doanh nghiệp đang trống"
};

export const VALIDATE_MESSAGE = {
  required: "Thông tin này bắt buộc nhập",
  notEnoughPoint: '2 điểm tọa độ không đủ xác định vùng của công trình',
  Point_error: 'Chỉ có 1 tọa độ công trình nước mặt',

};

export const API_ENDPOINT_DEV = "https://gengateway.azure-api.net";

export const TypeFiles = ["", "text/plain", "application/pdf", "application/vnd.ms-word", "application/vnd.ms-excel", 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "image/png", "image/jpeg", "image/jpeg", "image/gif", "text/csv",
  'application/x-rar-compressed', 'application/x-rar', 'application/octet-stream', 'application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip', 'application/msword']
